module.exports = __webpack_public_path__ + "static/media/media.3cb13cb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/stats/media.svg
// module id = 253
// module chunks = 1